export { default as BTNPrimary } from './Button.primary';
